const companies = [
    {
       name: "Microsoft",
       ctc:"44",
       cse:"9",
       ece:"6",
       mech:"-",
       civil:"-",
       chemical:"-",
       electrical:"-",
       desc:"Recruitment information Regarding Microsoft",
       rounds: "Coding, Technical 1, Technical 2, HR"
    },
    {
        name: "Amazon",
        ctc:"32",
        cse:"5",
        ece:"3",
        mech:"1",
        civil:"-",
        chemical:"-",
        electrical:"1",
        desc:"Recruitment information Regarding Amazon",
        rounds: "Coding, Technical 1, Technical 2, HR"
    },
    {
        name: "Google",
        ctc:"25",
        cse:"2",
        ece:"-",
        mech:"-",
        civil:"-",
        chemical:"-",
        electrical:"-",
        desc:"Recruitment information Regarding Google",
        rounds: "Coding, Technical 1, Technical 2, Hr round 1, HR round 2"
    },
    {
        name: "Goldman Sachs",
        ctc:"35",
        cse:"9",
        ece:"6",
        mech:"1",
        civil:"-",
        chemical:"-",
        electrical:"-",
        desc:"Recruitment information Regarding Goldman Sachs",
        rounds: "Coding, Technical 1, Technical 2, HR1, HR2"
    },
    {
        name: "JPMC",
        ctc:"28",
        cse:"7",
        ece:"2",
        mech:"3",
        civil:"1",
        chemical:"-",
        electrical:"2",
        desc:"Recruitment information reagrding JPMC",
        rounds: "Coding, Technical 1, Technical 2, HR"
    },
    {
        name: "Microsoft",
        ctc:"44",
        cse:"9",
        ece:"6",
        mech:"-",
        civil:"-",
        chemical:"-",
        electrical:"-",
        desc:"Recruitment information Regarding Microsoft",
        rounds: "Coding, Technical 1, Technical 2, HR"
     },
     {
         name: "Amazon",
         ctc:"32",
         cse:"5",
         ece:"3",
         mech:"1",
         civil:"-",
         chemical:"-",
         electrical:"1",
         desc:"Recruitment information Regarding Amazon",
         rounds: "Coding, Technical 1, Technical 2, HR"
     },
     {
         name: "Google",
         ctc:"25",
         cse:"2",
         ece:"-",
         mech:"-",
         civil:"-",
         chemical:"-",
         electrical:"-",
         desc:"Recruitment information Regarding Google",
         rounds: "Coding, Technical 1, Technical 2, Hr round 1, HR round 2"
     },
     {
         name: "Goldman Sachs",
         ctc:"35",
         cse:"9",
         ece:"6",
         mech:"1",
         civil:"-",
         chemical:"-",
         electrical:"-",
         desc:"Recruitment information Regarding Goldman Sachs",
         rounds: "Coding, Technical 1, Technical 2, HR1, HR2"
     },
     {
         name: "JPMC",
         ctc:"28",
         cse:"7",
         ece:"2",
         mech:"3",
         civil:"1",
         chemical:"-",
         electrical:"2",
         desc:"Recruitment information reagrding JPMC",
         rounds: "Coding, Technical 1, Technical 2, HR"
     },
     {
        name: "Microsoft",
        ctc:"44",
        cse:"9",
        ece:"6",
        mech:"-",
        civil:"-",
        chemical:"-",
        electrical:"-",
        desc:"Recruitment information Regarding Microsoft",
        rounds: "Coding, Technical 1, Technical 2, HR"
     },
     {
         name: "Amazon",
         ctc:"32",
         cse:"5",
         ece:"3",
         mech:"1",
         civil:"-",
         chemical:"-",
         electrical:"1",
         desc:"Recruitment information Regarding Amazon",
         rounds: "Coding, Technical 1, Technical 2, HR"
     },
     {
         name: "Google",
         ctc:"25",
         cse:"2",
         ece:"-",
         mech:"-",
         civil:"-",
         chemical:"-",
         electrical:"-",
         desc:"Recruitment information Regarding Google",
         rounds: "Coding, Technical 1, Technical 2, Hr round 1, HR round 2"
     },
     {
         name: "Goldman Sachs",
         ctc:"35",
         cse:"9",
         ece:"6",
         mech:"1",
         civil:"-",
         chemical:"-",
         electrical:"-",
         desc:"Recruitment information Regarding Goldman Sachs",
         rounds: "Coding, Technical 1, Technical 2, HR1, HR2"
     },
     {
         name: "JPMC",
         ctc:"28",
         cse:"7",
         ece:"2",
         mech:"3",
         civil:"1",
         chemical:"-",
         electrical:"2",
         desc:"Recruitment information reagrding JPMC",
         rounds: "Coding, Technical 1, Technical 2, HR"
     },
     {
        name: "Microsoft",
        ctc:"44",
        cse:"9",
        ece:"6",
        mech:"-",
        civil:"-",
        chemical:"-",
        electrical:"-",
        desc:"Recruitment information Regarding Microsoft",
        rounds: "Coding, Technical 1, Technical 2, HR"
     },
     {
         name: "Amazon",
         ctc:"32",
         cse:"5",
         ece:"3",
         mech:"1",
         civil:"-",
         chemical:"-",
         electrical:"1",
         desc:"Recruitment information Regarding Amazon",
         rounds: "Coding, Technical 1, Technical 2, HR"
     },
     {
         name: "Google",
         ctc:"25",
         cse:"2",
         ece:"-",
         mech:"-",
         civil:"-",
         chemical:"-",
         electrical:"-",
         desc:"Recruitment information Regarding Google",
         rounds: "Coding, Technical 1, Technical 2, Hr round 1, HR round 2"
     },
     {
         name: "Goldman Sachs",
         ctc:"35",
         cse:"9",
         ece:"6",
         mech:"1",
         civil:"-",
         chemical:"-",
         electrical:"-",
         desc:"Recruitment information Regarding Goldman Sachs",
         rounds: "Coding, Technical 1, Technical 2, HR1, HR2"
     },
     {
         name: "JPMC",
         ctc:"28",
         cse:"7",
         ece:"2",
         mech:"3",
         civil:"1",
         chemical:"-",
         electrical:"2",
         desc:"Recruitment information reagrding JPMC",
         rounds: "Coding, Technical 1, Technical 2, HR"
     },
     

]
export default companies